import lowerFirst from './lowerFirst';

/**
 * @param {string} prefix
 * @param {string} value
 */
export default function unPrefixPropName(prefix, value) {
  return lowerFirst(value.replace(prefix, ''));
}


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/utils/unPrefixPropName.js
// module id = 477
// module chunks = 1